import { render, staticRenderFns } from "./TipoVeiculoManage.vue?vue&type=template&id=66ccfe18&scoped=true"
import script from "./TipoVeiculoManage.vue?vue&type=script&lang=js"
export * from "./TipoVeiculoManage.vue?vue&type=script&lang=js"
import style0 from "./TipoVeiculoManage.vue?vue&type=style&index=0&id=66ccfe18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ccfe18",
  null
  
)

export default component.exports